module.exports = {
	nav: {
		home: 'Home',						// 首页
		about: 'About us',					// 关于我们
		project: 'Project Site Pictures',					// 项目实景
		contact: 'Contact us',				// 联系我们
		language: 'Language',			// 语言选择
	},
	content: {
		// 2021/11/12 内容区 要首字母大写
		about: 'About Us',					// 关于我们
		contact: 'Contact Us',				// 联系我们
	},
	contact: {
		xing: 'Last Name',		// 姓
		name: 'First Name',		// 名
		email: 'Email',		// 邮箱
		address: 'Address',	// 住址
		zhushi: 'Opinions',		// 注释
		submit: 'Submit',		// 提交
		bitian: 'Required',	// 必填項
		
		inputXing: '请输入您的姓氏ying',			// 请输入您的姓氏
		inputName: '请输入您的名字ying',			// 请输入您的名字
		inputZqEmail: 'Please enter a valid E_mail',	// 请输入有效的邮箱号
		
	}
}